module.exports = __webpack_public_path__ + "static/videoImage-f01c46c0b409dada98bb2d1673c1e2fc.png";